import React from 'react';
import { Navigate } from 'react-router-dom';
import { getIsPortalAdmin } from '../utils/storage';

// Guards portal-admin-only routes (Apps registry, install-wide Dashboard). Non-portal
// admins are bounced to an app-scoped page instead of hitting a backend 403. This is a
// UX/defense-in-depth layer — the backend portalAdminRole gate is the real enforcement.
const PortalAdminRoute = ({ children }) => {
    if (!getIsPortalAdmin()) {
        return <Navigate to="/users" replace />;
    }
    return children;
};

export default PortalAdminRoute;
